import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75647f61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "v-certification" }
const _hoisted_2 = { class: "v-certification__intro__txt lo-view__header__txt lo-remove-child-margin lo-g-gutter--half" }
const _hoisted_3 = {
  key: 0,
  class: "v-certification__form lo-view__form lo-g-gutter--half"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Veuillez vous identifier pour accéder à cette page", -1))
const _hoisted_5 = { class: "v-certification__specification lo-font-is-small lo-g-gutter--half" }
const _hoisted_6 = { class: "lo-g-box" }
const _hoisted_7 = { class: "lo-g-gutter--half" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Level One ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Nicolas Commergnat - Genève ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lo-g-gutter--half" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Spécifications")
], -1))
const _hoisted_13 = { class: "lo-g-box" }
const _hoisted_14 = { class: "lo-g-gutter--half" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "v-certification__components lo-g-gutter--half" }
const _hoisted_17 = { class: "lo-g-box" }
const _hoisted_18 = { class: "v-certification__components__header lo-remove-child-margin lo-g-gutter--half" }
const _hoisted_19 = { class: "v-certification__components__header__line" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Composante", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Vous trouverez un scann en haute définiton et un numéro de référence pour chaques pièces qui compose votre montre.", -1))
const _hoisted_22 = { class: "v-certification__components__elements lo-g-box lo-g-gutter--half" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "v-certification__components__elements__title lo-remove-child-margin lo-g-gutter--half" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Montre")
], -1))
const _hoisted_24 = { class: "v-certification__components__elements__description lo-remove-child-margin lo-g-gutter--half" }
const _hoisted_25 = { class: "v-certification__components__elements__list lo-g-box" }
const _hoisted_26 = { class: "v-certification__components__elements lo-g-box lo-g-gutter--half" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "v-certification__components__elements__title lo-remove-child-margin lo-g-gutter--half" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Boitier")
], -1))
const _hoisted_28 = { class: "v-certification__components__elements__description lo-remove-child-margin lo-g-gutter--half" }
const _hoisted_29 = { class: "v-certification__components__elements__list lo-g-box" }
const _hoisted_30 = { class: "v-certification__components__elements lo-g-box lo-g-gutter--half" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "v-certification__components__elements__title lo-remove-child-margin lo-g-gutter--half" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Cadrant")
], -1))
const _hoisted_32 = { class: "v-certification__components__elements__description lo-remove-child-margin lo-g-gutter--half" }
const _hoisted_33 = { class: "v-certification__components__elements__list lo-g-box" }
const _hoisted_34 = { class: "v-certification__components__elements lo-g-box lo-g-gutter--half" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "v-certification__components__elements__title lo-remove-child-margin lo-g-gutter--half" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Aiguilles")
], -1))
const _hoisted_36 = { class: "v-certification__components__elements__description lo-remove-child-margin lo-g-gutter--half" }
const _hoisted_37 = { class: "v-certification__components__elements__list lo-g-box" }
const _hoisted_38 = { class: "v-certification__components__elements lo-g-box lo-g-gutter--half" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "v-certification__components__elements__title lo-remove-child-margin lo-g-gutter--half" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Mouvement")
], -1))
const _hoisted_40 = { class: "v-certification__components__elements__description lo-remove-child-margin lo-g-gutter--half" }
const _hoisted_41 = { class: "v-certification__components__elements__list lo-g-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_locked_page = _resolveComponent("form-locked-page")!
  const _component_watch_component = _resolveComponent("watch-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "v-certification__intro lo-view__header",
      style: _normalizeStyle({backgroundImage: `url('${_ctx.certificationLoginData.image?.url}')`,})
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.certificationLoginData.titleName), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.certificationLoginData.description), 1)
      ])
    ], 4),
    (_ctx.certificationData === undefined || _ctx.certificationData?.hasOwnProperty('error'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_form_locked_page, { onValidate: _ctx.formValidate }, null, 8, ["onValidate"])
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _createElementVNode("h2", null, [
                    _hoisted_8,
                    _hoisted_9,
                    _hoisted_10,
                    _hoisted_11,
                    _createTextVNode("N* de ref. " + _toDisplayString(_ctx.certificationData?.ref.value), 1)
                  ])
                ])
              ]),
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", {
                  style: _normalizeStyle({
                backgroundImage: `url('${_ctx.certificationData?.image.url}')`,
              }),
                  class: "v-certification__specifications__img"
                }, null, 4)
              ]),
              (_ctx.certificationData)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    innerHTML: _ctx.certificationData.specification.value,
                    class: "v-certification__specifications__details lo-g-gutter--half lo-remove-child-margin"
                  }, null, 8, _hoisted_15))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    class: "v-certification__clearData",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearCertificationID && _ctx.clearCertificationID(...args)))
                  }, "logout")
                ]),
                _hoisted_20,
                _hoisted_21
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("p", null, _toDisplayString(_ctx.certificationData.watchDescription), 1)
              ]),
              _createElementVNode("div", _hoisted_25, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificationData?.watch, (component) => {
                  return (_openBlock(), _createBlock(_component_watch_component, { data: component }, null, 8, ["data"]))
                }), 256))
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("p", null, _toDisplayString(_ctx.certificationData.watchCaseDescription), 1)
              ]),
              _createElementVNode("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificationData?.watchCase, (component) => {
                  return (_openBlock(), _createBlock(_component_watch_component, { data: component }, null, 8, ["data"]))
                }), 256))
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("p", null, _toDisplayString(_ctx.certificationData.watchDialDescription), 1)
              ]),
              _createElementVNode("div", _hoisted_33, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificationData?.watchDial, (component) => {
                  return (_openBlock(), _createBlock(_component_watch_component, { data: component }, null, 8, ["data"]))
                }), 256))
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("p", null, _toDisplayString(_ctx.certificationData.watchNeedleDescription), 1)
              ]),
              _createElementVNode("div", _hoisted_37, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificationData?.watchNeedle, (component) => {
                  return (_openBlock(), _createBlock(_component_watch_component, { data: component }, null, 8, ["data"]))
                }), 256))
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("p", null, _toDisplayString(_ctx.certificationData.movementDescription), 1)
              ]),
              _createElementVNode("div", _hoisted_41, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificationData?.movement, (component) => {
                  return (_openBlock(), _createBlock(_component_watch_component, { data: component }, null, 8, ["data"]))
                }), 256))
              ])
            ])
          ])
        ], 64))
  ]))
}